// frontend/src/components/Dashboard/DashboardTabs.jsx
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const DashboardTabs = ({ tabs, activeTab, onTabChange }) => {
  if (!tabs || tabs.length === 0) {
    return null;
  }

  return (
    <div className="dashboard-tabs">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={activeTab === tab.id ? "active" : ""}
          onClick={() => onTabChange(tab.id)}
          aria-label={`Switch to ${tab.label}`}
        >
          <FontAwesomeIcon icon={tab.icon} /> {tab.label}
        </button>
      ))}
    </div>
  );
};

export default DashboardTabs;